import { DEFAULT_SETTINGS_TAB } from '../constants';

export type SettingsTab =
  | 'accessControl'
  | 'agentCard'
  | 'apikeys'
  | 'cache'
  | 'widget'
  | 'contentFilters'
  | 'mcp'
  | 'model'
  | 'sources';

/* Same order as settings sidebar (alphabetical by label).
   'agentCard' is valid for all domain types: every domain's MCP tool
   description is generated from its own Agent Card. 'contentFilters' is valid
   for all domain types (orchestrators pass filters down to their source sites).
   'sources' is only valid for orchestrator domains. */
export const SETTINGS_TAB_IDS: readonly SettingsTab[] = [
  'accessControl',
  'agentCard',
  'apikeys',
  'cache',
  'widget',
  'contentFilters',
  'mcp',
  'model',
  'sources',
];

const isSettingsTab = (value: string): value is SettingsTab =>
  (SETTINGS_TAB_IDS as readonly string[]).includes(value);

/**
 * Resolves the `settingsTab` query value to a known tab. Missing, unknown, or
 * retired values (e.g. links to a removed tab) fall back to the default, so
 * the Settings content and sidebar selection always agree.
 */
export const resolveSettingsTab = (query: string | null): SettingsTab =>
  query && isSettingsTab(query) ? query : DEFAULT_SETTINGS_TAB;
